import { render } from "./WasmScreen.vue?vue&type=template&id=03808aa7&ts=true"
import script from "./WasmScreen.vue?vue&type=script&lang=ts"
export * from "./WasmScreen.vue?vue&type=script&lang=ts"

import "./WasmScreen.vue?vue&type=style&index=0&id=03808aa7&lang=css"

import exportComponent from "/vue/cubetrain/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__